import './style.scss';

import { useNavigate } from '@reach/router';
import { Card, Skeleton } from 'antd';
import moment from 'moment/moment';
import { useState } from 'react';

import { Online } from '../../assets/images';
import { MEMBERS_ROUTES } from '../../pages/MainView/components/MembersAreaMain/members_routes';

const { Meta } = Card;

export const ProfileCard = ({ profile }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const navigate = useNavigate();
  const { username, avatar_image, id, birthday, online_status } = profile;
  const goToProfile = () =>
    navigate(`${MEMBERS_ROUTES.MEMBERSAREA}${MEMBERS_ROUTES.MEMBERPROFILE}/${id}`);
  return (
    <Card
      cover={
        <>
          {online_status ? (
            <img
              src={Online}
              style={{ width: 20, height: 20, position: 'absolute', top: 5, left: 5, zIndex: 5 }}
            />
          ) : null}
          <img
            style={{ visibility: !imageLoaded ? 'hidden' : 'visible' }}
            alt={username}
            src={avatar_image.thumbnail_url}
            loading={'lazy'}
            onLoad={(event) => setImageLoaded(event.type === 'load')}
          />
          {!imageLoaded && <Skeleton active />}
        </>
      }
      style={{ height: 218 }}
      onClick={goToProfile}
    >
      <Meta title={`${username}, ${moment().diff(birthday, 'years')}`} />
    </Card>
  );
};
